export default {
  BASE_URL: '/sob/purManage',
  api: [
    {
      name: 'purCompreList',
      path: '/purCompreList',
      method: 'POST',
      desc: '采购综合查询列表'
    },
    {
      name: 'purCompreListExe',
      path: '/purCompreListExe',
      method: 'POST',
      desc: '导出采购综合查询列表'
    },
    {
      name: 'supportEChartData',
      path: '/supportEChartData',
      method: 'POST',
      desc: '供应商统计图表'
    },
    {
      name: 'projEChartData',
      path: '/projEChartData',
      method: 'POST',
      desc: '项目统计图表'
    },
    {
      name: 'projList',
      path: '/projList',
      method: 'GET',
      desc: '项目列表'
    },
    {
      name: 'supportList',
      path: '/supportList',
      method: 'GET',
      desc: '供应商列表'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/statistics/purchase.js